import { render } from "./People.vue?vue&type=template&id=0e9bf2df&scoped=true"
import script from "./People.vue?vue&type=script&lang=js"
export * from "./People.vue?vue&type=script&lang=js"

import "./People.vue?vue&type=style&index=0&id=0e9bf2df&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e9bf2df"]])

export default __exports__